import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from '../services/permissions.service';

@Directive({
  selector: '[zonarPermission]'
})
export class PermissionsDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionsService: PermissionsService
  ) {}

  @Input() set zonarPermission(permission: string) {
    this.permissionsService.hasPermission(permission).subscribe(hasPerm => {
      if (!hasPerm && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      } else if (hasPerm && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    });
  }
}
